module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forward",
    attrs: {
      "id": "sec-11"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "pz11-1"
    }
  }, [_vm._v("\n\t\t\t\t\tAcknowledgments ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "pz11-2"
    }
  }, [_vm._v("\n\t\t\t\t\tI am deeply indebted to the twenty-eight women who entrusted their sermons and pieces\n\t\t\t\t\tof their stories into my keeping as this book came into being. I am grateful and\n\t\t\t\t\tproud of the contributions they make to the kingdom and to the history of women\n\t\t\t\t\tin the Churches of Christ. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "pz11-3"
    }
  }, [_vm._v("\n\t\t\t\t\tTo Kathy Pulley, whose insight and awareness of our history inspired me to collect\n\t\t\t\t\tthese sermons; ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "pz11-4"
    }
  }, [_vm._v("\n\t\t\t\t\tTo Carolyn Hunter, Peggy Winchel Huffman, Rhonda Lowry, Martha Scott, Carolyn Nicks,\n\t\t\t\t\tKathi Stafford, Patty Atkisson, and Regan and Robbie Schaffer for their hearts for\n\t\t\t\t\twomen in ministry and their encouragement and support of this project; ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "pz11-5"
    }
  }, [_vm._v("\n\t\t\t\t\tTo the churches and church leaders who courageously welcomed us to their pulpits\n\t\t\t\t\tand provided spaces where our voices could be heard; and ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-6"
    }
  }, [_vm._v("\n\t\t\t\t\tTo the colleges and universities that provided opportunities for learning and training\n\t\t\t\t\tin ministry and freely received our gifts of teaching, preaching, pastoral care,\n\t\t\t\t\tand public leadership in worship. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a63f90aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter03.vue
// module id = 75
// module chunks = 0